export class PageChange {
    constructor(_page: number, _direction: PageDirection) {
        this.page = _page;
        this.direction = _direction;
    }

    page: number;
    direction: PageDirection;
}

export enum PageDirection {
    keep = 0,
    back = 1,
    forward = 2
}
